import { createFileRoute } from '@tanstack/react-router';

import { Home } from '@/view/pages/Home';

export const Route = createFileRoute('/_protected/inicio')({
  component: Home,
  context: (context): { title: string } => ({
    ...context,
    title: 'Inicio',
  }),
});
